import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6a408c46"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "w-full max-w-site-max-w" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_3 = {
    key: 0,
    class: "text-xs text-gray-600 uppercase dark:text-gray-300"
};
const _hoisted_4 = {
    key: 0,
    class: "absolute top-0 left-0 flex items-center h-5 px-1 m-2 space-x-1 text-xs text-orange-500 bg-yellow-200 rounded dark:bg-gray-800"
};
const _hoisted_5 = {
    key: 0,
    class: "absolute px-2.5 py-1 bg-gray-700 rounded-full bottom-4 right-4"
};
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('views.retro.new.activity')
};
import { computed, watch, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import ActivityHelper from '@/components/new/ActivityHelper.vue';
import ActivityImage from '@/components/new/ActivityImage.vue';
import NamedCard from '@/components/new/NamedCard.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import { useConstantStore } from '@/pinia_stores/constant';
import { FEATURE_FLAGS } from '@/constants';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'ActivityPicker',
    props: {
        participantSlots: { default: 2 }
    },
    setup(__props) {
        const props = __props;
        const maturity = ref(1);
        const projectStage = ref(null);
        const topScoreBeforeTieRules = 3;
        const isPricingEnabled = FEATURE_FLAGS.PRICING_ENABLED;
        const store = useStore();
        const constantStore = useConstantStore();
        const isFreeWorkspace = computed(() => store.getters.isFreeWorkspace);
        const activities = computed(() => constantStore.activities);
        const selectedActivity = computed(() => store.state.newRetro.selectedActivity);
        onMounted(() => {
            selectActivity();
        });
        const sortedActivities = computed(() => {
            const calculateScore = (activity) => {
                const properties = activity.properties;
                let score = 0;
                const enoughParticipants = props.participantSlots >= properties.participants.min;
                const notTooManyParticipants = props.participantSlots <= properties.participants.max;
                if (enoughParticipants && notTooManyParticipants) {
                    score++;
                }
                const matureEnough = maturity.value >= properties.maturity.min;
                const notTooMature = maturity.value <= properties.maturity.max;
                if (matureEnough && notTooMature) {
                    score++;
                }
                if (properties.projectStage.includes(projectStage.value)) {
                    score++;
                }
                //When there's a score tie we add +1 to the score to have a preferred activity
                if (score === topScoreBeforeTieRules && properties.preferred) {
                    score++;
                }
                return score;
            };
            return activities.value
                .map((a) => {
                return {
                    ...a,
                    score: calculateScore(a),
                    value: a.id
                };
            })
                .sort((a1, a2) => a2.score - a1.score);
        });
        watch(sortedActivities, () => {
            store.commit('newRetro/selectActivity', sortedActivities.value[0].value);
        }, {
            deep: true
        });
        const selectActivity = (activity = null) => store.commit('newRetro/selectActivity', activity || sortedActivities.value[0].value);
        function isOptionTeamMaturityHighlighted(option) {
            return (option.properties.maturity.min <= maturity.value &&
                option.properties.maturity.max >= maturity.value);
        }
        function isOptionParticipantsAmountHighlighted(option) {
            return (option.properties.participants.min <= props.participantSlots &&
                option.properties.participants.max >= props.participantSlots);
        }
        function isOptionProjectStageHighlighted(option) {
            return (option.properties.projectStage.includes(projectStage.value) && projectStage.value !== 'standard');
        }
        function hasTheOptionAnyHighlight(option) {
            return (isOptionProjectStageHighlighted(option) ||
                isOptionTeamMaturityHighlighted(option) ||
                isOptionParticipantsAmountHighlighted(option));
        }
        return (_ctx, _cache) => {
            const _component_i18n_t = _resolveComponent("i18n-t");
            const _component_paragraph = _resolveComponent("paragraph");
            const _component_radio_cards = _resolveComponent("radio-cards");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(ActivityHelper, {
                    maturity: maturity.value,
                    "onUpdate:maturity": _cache[0] || (_cache[0] = ($event) => ((maturity).value = $event)),
                    "project-stage": projectStage.value,
                    "onUpdate:project-stage": _cache[1] || (_cache[1] = ($event) => ((projectStage).value = $event))
                }, null, 8, ["maturity", "project-stage"]),
                _createVNode(NamedCard, {
                    name: _ctx.$t('picker_title')
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_radio_cards, {
                            value: _unref(selectedActivity),
                            options: _unref(sortedActivities),
                            class: "mb-24",
                            onInput: selectActivity
                        }, {
                            name: _withCtx((option) => [
                                _createTextVNode(_toDisplayString(_ctx.$t(`activities.${option.value}.name`)), 1)
                            ]),
                            thumbnail: _withCtx((option) => [
                                _createVNode(ActivityImage, {
                                    class: "w-full h-full",
                                    activity: option
                                }, null, 8, ["activity"])
                            ]),
                            details: _withCtx((option) => [
                                _createVNode(_component_i18n_t, {
                                    keypath: `activities.${option.value}.description`,
                                    tag: "p",
                                    class: "flex-1 mb-6 text-xs leading-none'"
                                }, {
                                    default: _withCtx(() => [
                                        _hoisted_2
                                    ], undefined, true),
                                    _: 2
                                }, 1032, ["keypath"]),
                                (hasTheOptionAnyHighlight(option))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t('activity_highlights')), 1))
                                    : _createCommentVNode("", true),
                                (isOptionParticipantsAmountHighlighted(option))
                                    ? (_openBlock(), _createBlock(_component_paragraph, {
                                        key: 1,
                                        small: ""
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('participants.best_for', {
                                                min: option.properties.participants.min,
                                                max: option.properties.participants.max
                                            })), 1)
                                        ], undefined, true),
                                        _: 2
                                    }, 1024))
                                    : _createCommentVNode("", true),
                                (isOptionTeamMaturityHighlighted(option))
                                    ? (_openBlock(), _createBlock(_component_paragraph, {
                                        key: 2,
                                        small: ""
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(`maturity_${maturity.value}.best_for`)), 1)
                                        ], undefined, true),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true),
                                (isOptionProjectStageHighlighted(option))
                                    ? (_openBlock(), _createBlock(_component_paragraph, {
                                        key: 3,
                                        small: ""
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t(`project_stage.${projectStage.value}.best_for`)), 1)
                                        ], undefined, true),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true)
                            ]),
                            badge: _withCtx((option) => [
                                (option.score >= topScoreBeforeTieRules)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                        _createVNode(SvgIcon, {
                                            name: "star",
                                            class: "w-2 h-2 fill-orange-500 dark:fill-orange-500"
                                        }),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('recommended')), 1)
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            flag: _withCtx((option) => [
                                (!option.isFree && _unref(isFreeWorkspace) && _unref(isPricingEnabled))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                        _createVNode(SvgIcon, {
                                            name: "crown",
                                            class: "w-4"
                                        })
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }, 8, ["value", "options"])
                    ], undefined, true),
                    _: 1
                }, 8, ["name"])
            ]));
        };
    }
});
